/**
 * Legacy public/member exercise routes vs trainer Library (P2-R10).
 *
 * | Route | Member / public | Trainer (redirect) |
 * |-------|-----------------|---------------------|
 * | `/exercises` | Browse catalog | → `/trainer-dashboard` Library → Exercises tab |
 * | `/exercise/:id` | Exercise detail page | → hub + exercise detail drawer |
 *
 * Trainers should use Library for create/edit/view. `CreateExerciseForm` on `/exercises`
 * remains for members only.
 */

export type TrainerLibraryEntryState = {
  openLibraryExercises?: boolean;
  exerciseViewMode?: 'library' | 'myExercises';
  viewExerciseId?: string;
  editExerciseId?: string;
};

export function trainerLibraryEntryState(
  overrides: TrainerLibraryEntryState = {},
): TrainerLibraryEntryState {
  return {
    openLibraryExercises: true,
    exerciseViewMode: 'library',
    ...overrides,
  };
}
